import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/magic.svg";

const TermsPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title cp-page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center">
                <div className="col-lg-8 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" />
                      Termos de Uso
                    </span>
                    <h2 className="title">
                      Termos de Uso do site <br /> Somar Cloud - Seus direitos{" "}
                      <br /> e deveres de acesso
                    </h2>
                    <span className="page-update_time">
                      Atualizado em : 6 de julho de 2025
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-120 pb-75">
              <div className="row">
                <div className="col-lg-11">
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Direitos autorais e propriedade intelectual
                    </h2>
                    <p>
                      Todo o conteúdo deste website, incluindo textos, gráficos,
                      logotipos e marcas comerciais, é de propriedade
                      intelectual da Somar Cloud e está protegido por direitos
                      autorais, marcas registradas e outras leis aplicáveis. O
                      uso não autorizado, reprodução ou distribuição deste
                      material pode violar essas leis, levando a possíveis
                      consequências legais conforme a Lei de Direitos Autorais
                      (Lei 9.610/98).
                    </p>
                    <p>
                      A Somar Cloud não se responsabiliza por logotipos de
                      terceiros presentes no site; seus direitos autorais
                      permanecem com seus respectivos proprietários. Os usuários
                      concordam em não copiar, republicar, baixar, transmitir,
                      modificar, alugar, emprestar, vender, distribuir,
                      licenciar ou criar obras derivadas de qualquer conteúdo ou
                      serviços oferecidos através deste site sem permissão
                      expressa.
                    </p>
                    <p>
                      As imagens neste website podem incluir fotos de estoque
                      licenciadas, sobre as quais a Somar Cloud não reivindica
                      propriedade de direitos autorais. Todas as outras marcas
                      comerciais e nomes comerciais são propriedades de seus
                      respectivos proprietários.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Termos de uso do website
                    </h2>
                    <p>
                      Ao acessar este website, você concorda em cumprir os
                      seguintes termos. Você não deve reproduzir, modificar ou
                      distribuir qualquer conteúdo—incluindo textos, imagens,
                      gráficos, vídeos e áudio—para uso público ou comercial sem
                      autorização. O uso não autorizado de material do website
                      pode resultar em penalidades civis ou criminais conforme a
                      legislação brasileira. A Somar Cloud reserva todos os
                      direitos não expressamente concedidos neste documento.
                    </p>
                    <p>
                      Além disso, os usuários não devem submeter ou transmitir
                      qualquer material ilegal, abusivo, difamatório ou ofensivo
                      através deste website. Informações de contato, incluindo
                      endereços de e-mail encontrados aqui, não devem ser usadas
                      para comunicações não solicitadas ou promocionais.
                    </p>
                    <p>
                      This website may contain links to external sites. Innomax
                      disclaims any responsibility for the content or privacy
                      practices of third-party sites accessed through such
                      links. Visiting these sites is solely at the user’s own
                      risk.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Software e serviços
                    </h2>
                    <p>
                      Nossos serviços, fornecidos "como estão" e "conforme
                      disponíveis", são regidos por contratos juridicamente
                      vinculativos que estabelecem termos específicos de
                      serviço. Você deve dar consentimento expresso a esses
                      termos para iniciar o serviço, tornando o acordo
                      vinculativo para ambas as partes. Todos os serviços estão
                      sujeitos às leis brasileiras aplicáveis, incluindo o
                      Código de Defesa do Consumidor (Lei 8.078/90) e o Marco
                      Civil da Internet (Lei 12.965/14).
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Política de dados pessoais
                    </h2>
                    <p>
                      A Somar Cloud adere às melhores práticas de negócios e
                      protege suas informações pessoais de acordo com nossa
                      Política de Privacidade e em conformidade com a Lei Geral
                      de Proteção de Dados (LGPD - Lei 13.709/18). Coletamos,
                      tratamos e armazenamos dados pessoais apenas para
                      finalidades específicas e com base legal adequada,
                      garantindo transparência e controle sobre seus dados.
                      Consulte nossa Política de Privacidade para informações
                      detalhadas sobre como tratamos seus dados pessoais.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Isenção de responsabilidade
                    </h2>
                    <p>
                      As informações neste website são fornecidas de boa-fé e
                      provenientes de fontes confiáveis. No entanto, podem
                      conter imprecisões ou erros tipográficos. A Somar Cloud
                      não oferece garantias expressas ou implícitas sobre as
                      informações, produtos ou serviços disponíveis neste site,
                      e não deve ser considerado como consultoria profissional.
                      Sempre consulte profissionais qualificados para
                      orientações específicas sobre seus negócios ou
                      necessidades técnicas.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Limitação de responsabilidade
                    </h2>
                    <p>
                      A Somar Cloud limita sua responsabilidade por quaisquer
                      danos, incluindo perda de dados ou lucros,
                      independentemente de previsibilidade ou notificação
                      prévia, respeitando as disposições do Código Civil
                      brasileiro (Lei 10.406/02) e do Código de Defesa do
                      Consumidor (Lei 8.078/90). Esta limitação pode não se
                      aplicar em jurisdições que proíbem a exclusão de
                      responsabilidade por danos pessoais ou em casos de dolo ou
                      culpa grave.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Foro e legislação aplicável
                    </h2>
                    <p>
                      Estes Termos de Uso são regidos pelas leis brasileiras,
                      incluindo o Código Civil (Lei 10.406/02), o Código de
                      Defesa do Consumidor (Lei 8.078/90), o Marco Civil da
                      Internet (Lei 12.965/14) e a Lei Geral de Proteção de
                      Dados (LGPD - Lei 13.709/18). Fica eleito o foro da
                      comarca de São Paulo, Estado de São Paulo, para dirimir
                      quaisquer controvérsias decorrentes destes termos,
                      renunciando as partes a qualquer outro, por mais
                      privilegiado que seja.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Alterações dos termos
                    </h2>
                    <p>
                      A Somar Cloud reserva-se o direito de modificar estes
                      Termos de Uso a qualquer momento, mediante publicação da
                      versão atualizada em nosso website. As alterações entrarão
                      em vigor imediatamente após sua publicação. Recomendamos
                      que você revise periodicamente estes termos para estar
                      ciente de quaisquer mudanças. O uso continuado do site
                      após a publicação de alterações constituirá sua aceitação
                      dos termos modificados.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Contato</h2>
                    <p>
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="details-link"
                      >
                        Clique aqui
                      </Link>{" "}
                      para entrar em contato conosco sobre estes Termos e
                      Condições ou outras questões relacionadas. Você também
                      pode nos enviar um e-mail para: 
                      <a href="mailto:atendimento@somarcloud.com.br">
                        atendimento@somarcloud.com.br
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CtaSection cClass={"bg"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TermsPage;
